import { render, staticRenderFns } from "./notificationsDropdown.vue?vue&type=template&id=60a79f2c&scoped=true"
import script from "./notificationsDropdown.vue?vue&type=script&lang=js"
export * from "./notificationsDropdown.vue?vue&type=script&lang=js"
import style0 from "./notificationsDropdown.vue?vue&type=style&index=0&id=60a79f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a79f2c",
  null
  
)

export default component.exports